/**
 * Runtime configuration derived from the current hostname.
 *
 * The pipeline builds the frontend ONCE and deploys the same artifact to both
 * beta and prod. Build-time env vars (VITE_*) can't differ per stage, so we
 * derive the stage at runtime from the hostname and map to the correct
 * API, Cognito, and catalog URLs.
 *
 * For local dev (localhost), falls back to VITE_* env vars or beta defaults.
 */

type Stage = 'beta' | 'prod' | 'local';

function detectStage(): Stage {
  const host = window.location.hostname;
  // Beta: beta.new.hyghvybe.com or beta.hyghvybe.com
  if (host === 'beta.hyghvybe.com' || host.startsWith('beta.')) return 'beta';
  if (host === 'new.hyghvybe.com' || host === 'hyghvybe.com' || host === 'www.hyghvybe.com') return 'prod';
  return 'local';
}

const STAGE = detectStage();

// ── Per-stage configuration ─────────────────────────────────────────────────

const CONFIG = {
  beta: {
    apiBaseUrl: 'https://q1ki92zfth.execute-api.us-east-1.amazonaws.com/beta',
    cognitoDomain: 'auth-beta.new.hyghvybe.com',
    cognitoClientId: '76rirg5ltd83d1feg9a7bitdh3',
    catalogUrl: 'https://hv-images-beta.s3.us-east-1.amazonaws.com/catalog/products.json',
    stage: 'beta' as const,
  },
  prod: {
    apiBaseUrl: 'https://io14647e0m.execute-api.us-east-1.amazonaws.com/prod',
    cognitoDomain: 'auth.new.hyghvybe.com',
    cognitoClientId: 'q96mr2jai56vb322l9l6c78bq',
    catalogUrl: 'https://hv-images-prod.s3.us-east-1.amazonaws.com/catalog/products.json',
    stage: 'prod' as const,
  },
  local: {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
    cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || 'auth-beta.new.hyghvybe.com',
    cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '76rirg5ltd83d1feg9a7bitdh3',
    catalogUrl: import.meta.env.VITE_CATALOG_URL || 'https://hv-images-beta.s3.us-east-1.amazonaws.com/catalog/products.json',
    stage: 'beta' as const,
  },
};

export const appConfig = CONFIG[STAGE];
export const API_BASE = appConfig.apiBaseUrl;
export const COGNITO_DOMAIN = appConfig.cognitoDomain;
export const COGNITO_CLIENT_ID = appConfig.cognitoClientId;
export const CATALOG_URL = appConfig.catalogUrl;
export const STAGE_NAME = appConfig.stage;
